import { Box, makeStyles, Typography } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";
import * as React from "react";

import { layoutTokens, textStyles } from "@/designTokens";
import theme from "@/theme";

import chevron from "../../../../assets/image/settings_v2/chevron-muted.svg";

const useStyles = makeStyles({
  card: {
    width: "100%",
    minHeight: 50,
    padding: layoutTokens.space[16],
    border: 0,
    borderRadius: layoutTokens.radius.lg,
    backgroundColor: theme.palette.semantic["surface/card"],
    boxShadow: `0 2px 8px ${alpha(theme.palette.text.primary, 0.06)}`,
    display: "flex",
    alignItems: "center",
    gap: layoutTokens.space[12],
    textAlign: "left",
    color: theme.palette.text.primary,
    font: "inherit",
    cursor: "pointer",
    "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
  },
  selected: { backgroundColor: theme.palette.semantic["state/selected-bg"], borderRadius: layoutTokens.radius.md },
  column: { flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 4 },
  label: { ...textStyles["SP/Button/M"] },
  description: {
    ...textStyles["SP/Body/Small"],
    color: theme.palette.text.secondary,
    [theme.breakpoints.up("md")]: textStyles["PC/Body/Small"],
  },
  arrow: { width: 6, height: 10, flexShrink: 0 },
});

export const SettingsCard: React.FC<{
  label: string;
  description?: string;
  selected?: boolean;
  trailing?: React.ReactNode;
  onClick: () => void;
}> = ({ label, description, selected, trailing, onClick }) => {
  const classes = useStyles();
  return (
    <button
      type="button"
      className={`${classes.card} ${selected ? classes.selected : ""}`}
      onClick={onClick}
      aria-current={selected ? "page" : undefined}
    >
      <Box className={classes.column}>
        <Typography component="span" className={classes.label}>
          {label}
        </Typography>
        {description && (
          <Typography component="span" className={classes.description}>
            {description}
          </Typography>
        )}
      </Box>
      {trailing}
      <img className={classes.arrow} src={chevron} alt="" />
    </button>
  );
};
